export default __webpack_public_path__ + "static/media/csw.231227c2.png";